<div id="labs">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class=" inner-card">
                    <h4 class="card-title ">Chemistry Lab</h4>
                    <div class="card-body text-justify">
                      <p class="inner-lead"><i>" CHEMIST : WE ARE PERFECT FOR SOLVING PROBLEMS BECAUSE WE HAVE ALL THE SOLUTIONS "</i></p>
                        <!-- <h5>Chemistry XII eBooks Link</h5>
                        <hr class="opacity-100">
                        <div class="ranked">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">Particular</th>
                                    <th scope="col">Link</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?lech1=0-9">https://ncert.nic.in/textbook.php?lech1=0-9</a></td>
                                  </tr>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?lech2=0-7">https://ncert.nic.in/textbook.php?lech2=0-7</a></td>
                                  </tr>
                                  
                                </tbody>
                              </table>
                        </div>

                        <h5>Chemistry XI eBooks Link</h5>
                        <hr class="opacity-100">
                        <div class="ranked">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">Particular</th>
                                    <th scope="col">Link</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?kech1=0-7">https://ncert.nic.in/textbook.php?kech1=0-7</a></td>
                                  </tr>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?kech2=0-7">https://ncert.nic.in/textbook.php?kech2=0-7</a></td>
                                  </tr>
                                  
                                </tbody>
                              </table>
                        </div> -->
                        <div class="row">
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/campus/labs/1.jpg" data-lightbox="Chemistry"><img src="/assets/img/campus/labs/1.jpg" alt="Chemistry" class="img-fluid rounded"></a>
                            <h5 class="text-center mt-4">Chemistry</h5>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>